import type { FormalizationApi } from './formalization-api.types';

import http from './formalization-api.http';

export default {
  getInstallments: async ({ financingId }: FormalizationApi.GetInstallmentsParams) => {
    const res = await http.get<FormalizationApi.GetInstallmentsResponse>(
      `/v1/financings/${financingId}/installments`,
    );

    return res.data;
  },

  transferTitularity: async ({ newCustomerDocument, projectId }: FormalizationApi.TransferTitularityParams) => {
    const res = await http.patch<FormalizationApi.TransferTitularityResponse>(
      `/v1/financings/${projectId}/titularity`,
      { new_customer_document: newCustomerDocument } satisfies FormalizationApi.TransferTitularityRequest,
    );

    return res.data;
  },
};
